import api from './api';

const userService = {
  /**
   * Update user profile
   * @param {Object} userData - User data to update
   * @returns {Promise<Object>} Updated user data
   */
  async update(userData) {
    const response = await api.put('/api/user', userData);
    return response.data;
  },
  /**
   * Get location settings
   * @returns {Promise<Object>} Location settings
   */
  async getLocationSettings() {
    const response = await api.get('/api/user-location');
    return response.data;
  },
  /**
   * Get referral program data
   * @returns {Promise<Object>} Referral program data
   */
  async getReferralProgramData() {
    const response = await api.get('/api/user/referrals');
    return response.data;
  },

  /**
   * Set subscription tracking data
   * @param {Object} data - Subscription tracking data
   * @returns {Promise<Object>} Subscription tracking data
   */
  async setSubscriptionTrackingData(data) {
    const response = await api.post('/api/user/set-subscription-tracking', data);
    return response.data;
  },

  /**
   * Cancel subscription
   * @returns {Promise<Object>} Subscription cancellation data
   */
  async cancelSubscription() {
    const response = await api.delete('/api/user/subscription');
    return response.data;
  },

  /**
   * Create verification token
   * @returns {Promise<Object>} Verification token
   */
  async createVerificationToken() {
    const response = await api.post('/auth/identity-verification-token');
    return response.data;
  },

  async getStripeLogin(stripeId) {
    const response = await api.get('/api/user/get-stripe-login', { params: { stripe_id: stripeId } });
    return response.data;
  },

  /**
   * Get Stripe Customer Portal URL for payment method management
   * @param {string} stripeId - Stripe customer ID
   * @returns {Promise<Object>} Customer portal URL
   */
  async getStripeCustomerPortal(stripeId) {
    const response = await api.get('/api/user/stripe-customer-portal', { params: { stripe_id: stripeId } });
    return response.data;
  },
};

export default userService;